import React from 'react';
import { ShoppingCart, GraduationCap, Stethoscope, Building2, ArrowUpRight, TrendingUp, Clock, Users, ThumbsUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Seo from '../components/Seo';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { FinalCTA } from '../components/Sections';
import { SEGMENTS } from '../mock';
import { Button } from '../components/ui/button';

const iconMap = { ShoppingCart, GraduationCap, Stethoscope, Building2 };
const benefits = [
  { icon: TrendingUp, k: 'Mais vendas', v: 'Conversões dia e noite' },
  { icon: Clock, k: 'Menos espera', v: 'Respostas em segundos' },
  { icon: Users, k: 'Time livre', v: 'Foco no que importa' },
  { icon: ThumbsUp, k: 'CSAT alto', v: 'Clientes satisfeitos' },
];

const Block = ({ s, idx }) => {
  const Icon = iconMap[s.icon];
  const navigate = useNavigate();
  return (
    <section id={s.id} className={`py-20 ${idx % 2 === 0 ? 'bg-white' : 'bg-[#FAF6F2]'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid lg:grid-cols-2 gap-12 items-center ${idx % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''}`}>
          <div>
            <div className="w-14 h-14 rounded-2xl bg-[#FFF1EA] flex items-center justify-center">
              <Icon size={26} className="text-[#FF5B24]" />
            </div>
            <h2 className="mt-5 text-3xl md:text-4xl font-extrabold text-[#0a0e27]">{s.title}</h2>
            <p className="mt-3 text-lg font-semibold text-[#0a0e27]/80">{s.lead}</p>
            <p className="mt-4 text-slate-600 leading-relaxed">{s.body}</p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-xl bg-emerald-50 border border-emerald-100 px-4 py-3">
              <span className="text-emerald-700 text-sm font-semibold">{s.highlight}</span>
            </div>
            <div className="mt-8">
              <Button onClick={() => navigate('/contato')} className="btn-coral rounded-full h-12 px-6 text-sm font-semibold gap-1.5">
                Quero para meu negócio <ArrowUpRight size={16} />
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {benefits.map((b) => (
              <div key={b.k} className="bg-white rounded-2xl border border-slate-100 p-6 hover:shadow-lg transition">
                <div className="w-10 h-10 rounded-lg bg-[#0a0e27] flex items-center justify-center">
                  <b.icon size={18} className="text-[#FF5B24]" />
                </div>
                <div className="mt-4 font-extrabold text-lg text-[#0a0e27]">{b.k}</div>
                <div className="text-sm text-slate-500 mt-1">{b.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const Solucoes = () => (
  <>
    <Seo
      title="Soluções por segmento"
      description="Atendimento com IA sob medida para varejo, clínicas, escolas e empresas B2B. Veja como a CoreDesk se adapta à sua operação e escala suas vendas."
      path="/solucoes"
    />
    <Header />
    <PageHero
      eyebrow="Soluções por segmento"
      title="Feita para |o seu negócio"
      subtitle="Cada segmento tem particularidades. A CoreDesk se adapta à sua operação, seja você varejista, clínica, escola ou empresa B2B."
    />
    {SEGMENTS.map((s, i) => <Block key={s.id} s={s} idx={i} />)}
    <FinalCTA />
    <Footer />
  </>
);

export default Solucoes;
